import actions from 'actions'

import { CheckoutActionCreator } from 'routes/Checkout/models/ReduxTypes'

export const closeLoginModal: CheckoutActionCreator = (e?: MouseEvent) => (dispatch) => {
  e?.stopPropagation()

  dispatch(actions.loginVisibilityChange(false))
}
